/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable i18next/no-literal-string */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormContext, Controller } from 'react-hook-form';
import { useSelector } from 'react-redux';
import 'react-phone-input-2/lib/style.css';
import { Theme, TextField, Typography, Switch, FormControlLabel } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { LayoutGrid, LayoutGridItem } from 'app/layout/LayoutGrid';
import { candidateDetailsSelection, selectPersonalInfoDuplicates } from '../../../Profile/CandidateDetails.selector';
import { IDuplicateCandidateContact } from 'app/models/Candidate/CandidateProfile';
import { contactTypes, emailCheck, errorEmailMessage } from './PersonalInfoHelper';
import { FormInputCountryDropDown } from './Controls/FormInputCountryDropDown';
import { getSearchFilterOptions } from 'app/services/SharedServices/SharedServices';
import { cloneDeep } from 'lodash';
import { DuplicateContactTable } from '../../../CandidateHeader/Common/DuplicateContactTable';
import { useDecision } from '@optimizely/react-sdk';
import { ff_candidate_ui_contact_internal_optout } from 'app/constants/FeatureFlags/Candidate/Keys';

const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    padding: '0px 10px',
    minWidth: 0,
  },
  textColor: {
    color: '#0D6FB9',
    textAlign: 'left',
    font: 'normal normal medium 14px / 26px Roboto',
    fontWeight: 500,
    paddingLeft: 4,
  },
  inlineLink: {
    color: '#006FB9',
    'font-size': '14px',
    'font-weight': '600',
    'padding-left': '0.3rem',
    'text-decoration': 'underline',
    'white-space': 'nowrap',
    cursor: 'pointer',
  },
  inlineLinkDisabled: {
    color: '#dddddd',
    'font-size': '14px',
    'font-weight': '600',
    'padding-left': '0.3rem',
    'text-decoration': 'underline',
    'white-space': 'nowrap',
    cursor: 'not-allowed',
  },
  // eslint-disable-next-line tss-unused-classes/unused-classes
  '.react-tel-input.country-list.search': {
    width: 5,
  },
}));

export const ContactInfoSection = props => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const {
    control,
    setError,
    formState: { errors },
    clearErrors,
    watch,
  } = useFormContext();
  const candidateDetails = useSelector(candidateDetailsSelection);
  const personalInfoDuplicates = useSelector(selectPersonalInfoDuplicates);
  const [internalOptOutFlag] = useDecision(ff_candidate_ui_contact_internal_optout);
  const primaryEmailValue = watch('ciPrimaryEmail');
  const secondaryEmailValue = watch('ciSecondaryEmail');

  const enteredEmails = [primaryEmailValue, secondaryEmailValue].filter(Boolean).map(e => `${e}`.trim().toLowerCase());
  const hasDuplicates = personalInfoDuplicates?.length > 0;
  // Emails are the reliable form signal; anything not matching an email is treated as a phone duplicate.
  const matchesEnteredEmail = (dup: IDuplicateCandidateContact) =>
    [dup?.primaryEmail, dup?.secondaryEmail]
      .filter(Boolean)
      .map(e => `${e}`.trim().toLowerCase())
      .some(de => enteredEmails.includes(de));
  const isEmailDuplicate = hasDuplicates && personalInfoDuplicates.some(matchesEnteredEmail);
  const showDuplicatesNearEmail = isEmailDuplicate;
  const showDuplicatesNearPhone = hasDuplicates && !isEmailDuplicate;
  const duplicatesTable = (
    <LayoutGridItem
      item
      style={{ paddingTop: 16, width: '100%', minWidth: 0, display: 'grid', gridTemplateColumns: 'minmax(0, 1fr)' }}
    >
      <DuplicateContactTable duplicates={personalInfoDuplicates} />
    </LayoutGridItem>
  );
  const [secondaryEmail, setSecondaryEmail] = useState<boolean>(false);
  const [allContactTypes, setAllContactTypes] = useState<{ ID: number; Description: string }[]>(contactTypes);
  const [typeOptions, setTypeOptions] = useState<{ ID: number; Description: string }[]>(contactTypes);
  const [phoneNumbers, setPhoneNumbers] = useState<any[]>(
    candidateDetails.phoneNumbers?.filter(x => x.phoneNumber !== '') || [],
  );
  const [softDelPhnNumbers, setSoftDelPhnNumbers] = useState<Map<number, boolean>>(new Map<number, boolean>());

  useEffect(() => {
    (async () => {
      const response = await getSearchFilterOptions('phonetypes');
      if (Array.isArray(response) && response.length > 0) {
        const mapped = response
          .map(item => ({
            ID: parseInt(item?.value ?? item?.id ?? item?.ID),
            Description: item?.name ?? item?.description ?? item?.Description,
          }))
          .filter(item => !Number.isNaN(item.ID) && !!item.Description);
        if (mapped.length > 0) {
          setAllContactTypes(mapped);
        }
      }
    })();
  }, []);

  useEffect(() => {
    let tempTypes = allContactTypes;
    phoneNumbers.map(item => {
      tempTypes = tempTypes.filter(x => x.ID !== item.phoneTypeId);
    });
    setTypeOptions(tempTypes);
  }, [phoneNumbers, allContactTypes]);

  const addPhone = () => {
    if (typeOptions.length > 0) {
      const newPhoneType = typeOptions[0];
      setPhoneNumbers([
        ...phoneNumbers,
        {
          phoneTypeId: newPhoneType.ID,
          phoneTypeDescription: newPhoneType.Description,
          phoneNumber: '',
          countryDialingCode: '',
          extensionNotes: null,
          timeStamp: '',
        },
      ]);
      setTypeOptions(typeOptions.filter((item, index) => index !== 0));
      props.checkContactEdit();
    }
  };

  const addEmail = () => {
    setSecondaryEmail(true);
  };

  const getTypeOptions = type => {
    const permanentField2Type = 3;
    const current = allContactTypes.find(item => item.ID === type);
    const clonePhoneNumberOptions = cloneDeep(typeOptions);
    const phoneNumberOptions = clonePhoneNumberOptions.filter(item => item.ID !== permanentField2Type);
    return [...phoneNumberOptions, current];
  };

  const onChangeType = (current, newType) => {
    const updatedPhoneNumbers = phoneNumbers.map(item => {
      if (item.phoneTypeDescription === current) {
        return {
          ...item,
          phoneTypeDescription: newType,
        };
      } else {
        return item;
      }
    });
    setPhoneNumbers(updatedPhoneNumbers);
  };

  const handleChange = e => {
    switch (e?.target?.name) {
      case 'ciPrimaryEmail':
        errorEmailMessage(e, 'ciPrimaryEmail', setError);
        break;
      case 'ciSecondaryEmail':
        errorEmailMessage(e, 'ciSecondaryEmail', setError);
        break;
    }
  };

  const softDelete = (index: number) => {
    const deletedMaps = new Map<number, boolean>();
    softDelPhnNumbers.forEach((val, key) => {
      deletedMaps.set(key, val);
    });
    deletedMaps.set(index, true);
    setSoftDelPhnNumbers(deletedMaps);
  };

  useEffect(() => {
    if (phoneNumbers.length > 0 && softDelPhnNumbers.size === phoneNumbers.length) {
      props.handleShowInfoMessage();
    }
  }, [softDelPhnNumbers]);

  const undoDelete = (index: number) => {
    const deletedMaps = new Map<number, boolean>();
    softDelPhnNumbers.forEach((val, key) => {
      deletedMaps.set(key, val);
    });
    deletedMaps.delete(index);
    setSoftDelPhnNumbers(deletedMaps);
  };

  useEffect(() => {
    if (candidateDetails?.secondaryEmail) setSecondaryEmail(true);
  }, [candidateDetails.secondaryEmail]);

  return (
    <>
      <LayoutGrid container direction="column" className={classes.root}>
        <LayoutGridItem item style={{ paddingLeft: '6px' }}>
          <Typography className={classes.textColor} variant="subtitle1" gutterBottom component="div">
            {t('candidate.profileInformation.contactInformation')}
          </Typography>
        </LayoutGridItem>
        <LayoutGrid container direction="row" justifyContent="space-between">
          <LayoutGridItem item style={{ paddingLeft: 24 }}>
            <Typography variant="subtitle1" gutterBottom component="div" style={{ fontWeight: 500 }}>
              {t('candidate.profileInformation.phone')}
            </Typography>
          </LayoutGridItem>
          <LayoutGridItem item>
            <span
              className={typeOptions.length > 0 ? classes.inlineLink : classes.inlineLinkDisabled}
              onClick={() => addPhone()}
            >
              {t('candidate.profileSummaryCard.add')}
            </span>
          </LayoutGridItem>
        </LayoutGrid>

        {phoneNumbers.map((items, index) => {
          return (
            <Controller
              name={`phoneNumbers[${index}]`}
              control={control}
              render={({ field: { ref, value, onChange, ...rest } }) => (
                <FormInputCountryDropDown
                  key={index}
                  controllerName={`phoneNumbers[${index}]`}
                  name={items.phoneTypeDescription.replace(/\s/g, '')}
                  contactTypeName={items.phoneTypeDescription}
                  contactNumber={`${items.countryDialingCode}${items.phoneNumber}`}
                  options={getTypeOptions(items.phoneTypeId)}
                  onChangeType={onChangeType}
                  checkContactEdit={props.checkContactEdit}
                  isSoftDeleted={softDelPhnNumbers.has(index)}
                  onSoftDelete={() => softDelete(index)}
                  undoDelete={() => undoDelete(index)}
                  disabled={items.phoneTypeId === 3}
                />
              )}
            />
          );
        })}

        {showDuplicatesNearPhone && duplicatesTable}

        <LayoutGridItem item>
          <LayoutGrid container direction="row" justifyContent="space-between" marginTop="-24px">
            <LayoutGridItem item style={{ paddingLeft: 12, paddingTop: 20 }}>
              <Typography variant="subtitle1" gutterBottom component="div" style={{ fontWeight: 500 }}>
                {t('candidate.profileInformation.email')}
              </Typography>
            </LayoutGridItem>
            <LayoutGridItem item>
              <span
                className={!secondaryEmail ? classes.inlineLink : classes.inlineLinkDisabled}
                onClick={() => addEmail()}
              >
                {t('candidate.profileSummaryCard.add')}
              </span>
            </LayoutGridItem>
          </LayoutGrid>
        </LayoutGridItem>
        <LayoutGridItem item paddingTop="0px !important">
          <LayoutGrid container direction="row" data-testid="container" justifyContent="flex-start" spacing={4}>
            <LayoutGridItem item xs={10}>
              <Controller
                name="ciPrimaryEmail"
                control={control}
                render={({ field: { ref, onChange, onBlur, value, ...rest } }) => (
                  <TextField
                    variant="filled"
                    label="Primary"
                    fullWidth
                    {...rest}
                    value={value || ''}
                    onChange={e => {
                      onChange(e);
                      handleChange(e);
                    }}
                    onBlur={e => {
                      if (emailCheck(e?.target?.value)) {
                        clearErrors(['ciPrimaryEmail']);
                      }
                    }}
                    inputRef={ref}
                    error={!!errors['ciPrimaryEmail']}
                    helperText={errors['ciPrimaryEmail'] ? errors.ciPrimaryEmail.message : ''}
                  />
                )}
              />
            </LayoutGridItem>
            {internalOptOutFlag.enabled && (
              <LayoutGridItem item xs={10}>
                <Controller
                  name="ciPrimaryEmailOptOut"
                  control={control}
                  render={({ field: { value, onChange } }) => (
                    <FormControlLabel
                      control={
                        <Switch
                          color="primary"
                          checked={!!value}
                          onChange={e => onChange(e.target.checked)}
                          disabled={!emailCheck(primaryEmailValue) || !primaryEmailValue}
                          inputProps={{ 'aria-label': 'primary email internal opt out' }}
                        />
                      }
                      label={t('candidate.profileInformation.internalOptOut')}
                    />
                  )}
                />
              </LayoutGridItem>
            )}
          </LayoutGrid>
        </LayoutGridItem>
        {(candidateDetails.secondaryEmail || secondaryEmail) && (
          <LayoutGridItem item>
            <LayoutGrid container direction="row" data-testid="container" justifyContent="flex-start" spacing={4}>
              <LayoutGridItem item xs={10}>
                <Controller
                  name="ciSecondaryEmail"
                  control={control}
                  render={({ field: { ref, onChange, onBlur, value, ...rest } }) => (
                    <TextField
                      variant="filled"
                      label="Secondary"
                      fullWidth
                      {...rest}
                      value={value || ''}
                      onChange={e => {
                        onChange(e);
                        handleChange(e);
                      }}
                      onBlur={e => {
                        if (emailCheck(e?.target?.value)) {
                          clearErrors(['ciSecondaryEmail']);
                        }
                      }}
                      inputRef={ref}
                      error={!!errors['ciSecondaryEmail']}
                      helperText={errors['ciSecondaryEmail'] ? errors.ciSecondaryEmail.message : ''}
                    />
                  )}
                />
              </LayoutGridItem>
              {internalOptOutFlag.enabled && (
                <LayoutGridItem item xs={10}>
                  <Controller
                    name="ciSecondaryEmailOptOut"
                    control={control}
                    render={({ field: { value, onChange } }) => (
                      <FormControlLabel
                        control={
                          <Switch
                            color="primary"
                            checked={!!value}
                            onChange={e => onChange(e.target.checked)}
                            disabled={!emailCheck(secondaryEmailValue) || !secondaryEmailValue}
                            inputProps={{ 'aria-label': 'secondary email internal opt out' }}
                          />
                        }
                        label={t('candidate.profileInformation.internalOptOut')}
                      />
                    )}
                  />
                </LayoutGridItem>
              )}
            </LayoutGrid>
          </LayoutGridItem>
        )}
        {showDuplicatesNearEmail && duplicatesTable}
      </LayoutGrid>
    </>
  );
};
